import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import EditIcon from "@material-ui/icons/Edit";

const styles = (theme) => ({
  staticGroup: {
    display: "flex",
    alignItems: "baseline",
    "& p": {
      fontWeight: 500,
      fontSize: "14px",
      color: theme.palette.primary.main,
    },
  },
  editField: {
    "& .MuiInputBase-root.MuiInputBase-formControl": {
      marginTop: 0,
    },
    "& input": {
      fontSize: "14px",
      color: theme.palette.primary.main,
    },
  },
  btnGroup: {
    color: theme.palette.secondary.main,
    minHeight: 0,
    padding: 0,
    "& span": {
      fontSize: "14px",
    },
    "& svg": {
      fontSize: "14px",
    },
  },
});
class EditableTextField extends React.Component {
  state = {
    edit: false,
    value: this.props.value || "",
    validationResult: {
      status: true,
      message: "",
    },
  };

  onChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({ value }, () => {
      const validationResult = this.props.validation(
        name,
        this.state.value,
        this.props.isCurrency
      );
      this.setState({ validationResult });
    });
  };

  onFocus = (e) => {
    this.setState(
      {
        edit: true,
      },
      () => {
        this.input.focus();
      }
    );
  };

  onBlur = (e) => {
    if (this.state.validationResult.status) {
      this.setState({ edit: false }, this.props.onSave);
    }
  };

  onEnter = (e) => {
    if (e.key === "Enter" && this.state.validationResult.status) {
      this.setState({ edit: false }, this.props.onSave);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  render() {
    const { edit, value, validationResult } = this.state;
    const { disabled, classes, staticComponent, className, name } = this.props;
    const EditComponent = (
      <TextField
        value={value}
        error={!validationResult.status}
        helperText={validationResult.status ? "" : validationResult.message}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onKeyPress={this.onEnter}
        inputRef={(el) => (this.input = el)}
        className={`${classes.editField} ${className}`}
        name={name}
      />
    );
    const StaticComponent = (
      <div className={classes.staticGroup}>
        {staticComponent ? staticComponent : value}
        {!disabled && (
          <Button onClick={this.onFocus} className={classes.btnGroup}>
            <EditIcon />
            edit
          </Button>
        )}
      </div>
    );

    return edit ? EditComponent : StaticComponent;
  }
}

EditableTextField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  isCurrency: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  validation: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  staticComponent: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

EditableTextField.defaultProps = {
  isCurrency: false,
  staticComponent: null,
  className: "",
};

export default withStyles(styles)(EditableTextField);



// WEBPACK FOOTER //
// ./src/components/Forms/EditableTextField.jsx